import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { maschinentypenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Maschinentype {
    nr: number;
    name: string;
    text: string;
}

export const defaultMaschinentype: Maschinentype = {
    nr: 0,
    name: '',
    text: '',
};

export async function addMaschinentype(maschinentype: Maschinentype): Promise<void> {
    return callApi<void>(Controller.maschinentype + '/add', { maschinentype });
}

export async function updateMaschinentype(maschinentype: Maschinentype): Promise<void> {
    return callApi<void>(Controller.maschinentype + '/update', { maschinentype });
}

export async function deleteMaschinentype(maschinentype: Maschinentype): Promise<void> {
    return callApi<void>(Controller.maschinentype + '/update', { maschinentype });
}

export function useMaschinentypenAsOptions(): SelectOption[] {
    const maschinentypen = useSelector(maschinentypenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return maschinentypen.map(
            (maschinentype) =>
                ({
                    value: maschinentype.nr.toString(),
                    label: maschinentype.name,
                } as SelectOption),
        );
    }, [maschinentypen]);
}
